module.exports = __webpack_public_path__ + "static/westside-449303f23927d389f68cfc6de7951f97.svg";